import React from 'react';
import { styled } from '@compiled/react';
import { JiraIcon } from '@atlaskit/logo';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import AsanaLogomark from '@atlassian/jira-illustrations/src/ui/adg4/thirdparty/logos/components/asana-logomark';
import { useIntl } from '@atlassian/jira-intl';
import AsanaIcon from '../../../../../common/assets/Asana.svg';
import messages from './messages';

export const AsanaHierarchy = () => {
	const { formatMessage } = useIntl();

	return (
		<>
			<HeaderWrapper>
				{fg('x2c-consolidate-assets') ? (
					<Box xcss={asanaIconStyles}>
						<AsanaLogomark alt="Asana Icon" />
					</Box>
				) : (
					<Image src={AsanaIcon} aria-label="Asana" role="img" alt="" />
				)}
				<AsanaHeader>{formatMessage(messages.asanaHeading)}</AsanaHeader>
				<JiraIcon size="small" appearance="brand" />
				<Box xcss={jiraHeaderStyles}>{formatMessage(messages.jiraHeadingSpork)}</Box>
			</HeaderWrapper>
			<svg
				width="574"
				height="141"
				viewBox="0 0 574 141"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				role="img"
				aria-label={formatMessage(messages.illustrationLabelSpork)}
			>
				<g id="AsanaHierarchy">
					<g id="Asana">
						<rect id="Background" width="270" height="141" rx="6" fill="white" />
						<g id="Subsubtask">
							<g id="check-circle-outline">
								<rect
									width="24.1791"
									height="24"
									transform="translate(117 110)"
									fill="white"
									fillOpacity="0.01"
								/>
								<path
									d="M129.09 113C134.097 113 138.157 117.029 138.157 122C138.157 126.971 134.097 131 129.09 131C124.082 131 120.022 126.971 120.022 122C120.022 117.029 124.082 113 129.09 113ZM129.09 115C125.195 115 122.037 118.134 122.037 122C122.037 125.866 125.195 129 129.09 129C132.984 129 136.142 125.866 136.142 122C136.142 118.134 132.984 115 129.09 115ZM132.736 119.215L132.824 119.293C133.19 119.656 133.216 120.227 132.903 120.62L132.824 120.707L128.794 124.707C128.429 125.07 127.853 125.096 127.458 124.785L127.37 124.707L125.355 122.707C124.961 122.317 124.961 121.683 125.355 121.293C125.72 120.93 126.296 120.904 126.692 121.215L126.78 121.293L128.082 122.585L131.4 119.293C131.765 118.93 132.341 118.904 132.736 119.215Z"
									fill="#626F86"
								/>
							</g>
							<text
								fill="#172B4D"
								xmlSpace="preserve"
								fontSize="14"
								fontWeight="500"
								letterSpacing="0px"
							>
								<tspan x="146.216" y="127.477">
									{formatMessage(messages.asanaSubtask)}
								</tspan>
							</text>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M217.298 117V123C217.298 124.933 218.865 126.5 220.798 126.5H225.858V126.028C225.873 127.12 226.769 128 227.873 128C228.986 128 229.888 127.105 229.888 126C229.888 124.895 228.986 124 227.873 124C226.769 124 225.873 124.88 225.858 125.972V125.5H220.798C219.418 125.5 218.298 124.381 218.298 123V121.5H225.921C226.145 122.363 226.934 123 227.873 123C228.986 123 229.888 122.105 229.888 121C229.888 119.895 228.986 119 227.873 119C226.934 119 226.145 119.637 225.921 120.5H218.298V117H217.298ZM227.873 122C228.44 122 228.888 121.545 228.888 121C228.888 120.455 228.44 120 227.873 120C227.305 120 226.858 120.455 226.858 121C226.858 121.545 227.305 122 227.873 122ZM228.888 126C228.888 126.545 228.44 127 227.873 127C227.305 127 226.858 126.545 226.858 126C226.858 125.455 227.305 125 227.873 125C228.44 125 228.888 125.455 228.888 126Z"
								fill="#44546F"
							/>
						</g>
						<line x1="20" y1="104.5" x2="247.687" y2="104.5" stroke="#DCDFE4" />
						<g id="Subtask">
							<g id="check-circle-outline">
								<rect
									width="24.1791"
									height="24"
									transform="translate(86.4927 76)"
									fill="white"
									fillOpacity="0.01"
								/>
								<path
									d="M98.5822 79C103.59 79 107.649 83.0294 107.649 88C107.649 92.9706 103.59 97 98.5822 97C93.5746 97 89.5151 92.9706 89.5151 88C89.5151 83.0294 93.5746 79 98.5822 79ZM98.5822 81C94.6874 81 91.53 84.134 91.53 88C91.53 91.866 94.6874 95 98.5822 95C102.477 95 105.634 91.866 105.634 88C105.634 84.134 102.477 81 98.5822 81ZM102.229 85.2152L102.317 85.2929C102.682 85.6555 102.708 86.2274 102.395 86.6199L102.317 86.7071L98.2871 90.7071C97.9218 91.0697 97.3457 91.0956 96.9503 90.7848L96.8624 90.7071L94.8475 88.7071C94.454 88.3166 94.454 87.6834 94.8475 87.2929C95.2128 86.9303 95.7889 86.9044 96.1843 87.2152L96.2722 87.2929L97.5749 88.5853L100.892 85.2929C101.258 84.9303 101.834 84.9044 102.229 85.2152Z"
									fill="#626F86"
								/>
							</g>
							<text
								fill="#172B4D"
								xmlSpace="preserve"
								fontSize="14"
								fontWeight="500"
								letterSpacing="0px"
							>
								<tspan x="115.709" y="93.4766">
									{formatMessage(messages.asanaSubtask)}
								</tspan>
							</text>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M186.791 83V89C186.791 90.933 188.358 92.5 190.291 92.5H195.351V92.0282C195.366 93.1198 196.262 94 197.365 94C198.478 94 199.38 93.1046 199.38 92C199.38 90.8954 198.478 90 197.365 90C196.262 90 195.366 90.8802 195.351 91.9718V91.5H190.291C188.91 91.5 187.791 90.3807 187.791 89V87.5H195.414C195.638 88.3626 196.427 89 197.365 89C198.478 89 199.38 88.1046 199.38 87C199.38 85.8954 198.478 85 197.365 85C196.427 85 195.638 85.6374 195.414 86.5H187.791V83H186.791ZM197.365 88C197.933 88 198.38 87.5453 198.38 87C198.38 86.4547 197.933 86 197.365 86C196.798 86 196.351 86.4547 196.351 87C196.351 87.5453 196.798 88 197.365 88ZM198.38 92C198.38 92.5453 197.933 93 197.365 93C196.798 93 196.351 92.5453 196.351 92C196.351 91.4547 196.798 91 197.365 91C197.933 91 198.38 91.4547 198.38 92Z"
								fill="#44546F"
							/>
						</g>
						<line x1="20" y1="70.5" x2="247.687" y2="70.5" stroke="#DCDFE4" />
						<g id="Task">
							<path
								d="M42.9711 57.8007L37.8421 52.7097C37.2085 52.0808 37.6539 51 38.5466 51H48.8046C49.6973 51 50.1427 52.0809 49.5091 52.7097L44.3801 57.8007C43.9902 58.1878 43.361 58.1878 42.9711 57.8007Z"
								fill="#626F86"
							/>
							<g>
								<rect
									width="24.1791"
									height="24"
									transform="translate(59.291 42)"
									fill="white"
									fillOpacity="0.01"
								/>
								<path
									d="M71.3806 45C76.3882 45 80.4477 49.0294 80.4477 54C80.4477 58.9706 76.3882 63 71.3806 63C66.3729 63 62.3134 58.9706 62.3134 54C62.3134 49.0294 66.3729 45 71.3806 45ZM71.3806 47C67.4857 47 64.3283 50.134 64.3283 54C64.3283 57.866 67.4857 61 71.3806 61C75.2754 61 78.4328 57.866 78.4328 54C78.4328 50.134 75.2754 47 71.3806 47ZM75.0275 51.2152L75.1153 51.2929C75.4807 51.6555 75.5068 52.2274 75.1936 52.6199L75.1153 52.7071L71.0855 56.7071C70.7201 57.0697 70.144 57.0956 69.7486 56.7848L69.6607 56.7071L67.6458 54.7071C67.2524 54.3166 67.2524 53.6834 67.6458 53.2929C68.0111 52.9303 68.5872 52.9044 68.9827 53.2152L69.0705 53.2929L70.3733 54.5853L73.6906 51.2929C74.0559 50.9303 74.632 50.9044 75.0275 51.2152Z"
									fill="#626F86"
								/>
							</g>
							<text
								fill="#172B4D"
								xmlSpace="preserve"
								fontSize="14"
								fontWeight="500"
								letterSpacing="0px"
							>
								<tspan x="88.5073" y="60.4766">
									{formatMessage(messages.asanaTask)}
								</tspan>
							</text>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M135.403 50V56C135.403 57.933 136.97 59.5 138.903 59.5H143.963V59.0282C143.978 60.1198 144.874 61 145.977 61C147.09 61 147.992 60.1046 147.992 59C147.992 57.8954 147.09 57 145.977 57C144.874 57 143.978 57.8802 143.963 58.9718V58.5H138.903C137.522 58.5 136.403 57.3807 136.403 56V54.5H144.026C144.249 55.3626 145.038 56 145.977 56C147.09 56 147.992 55.1046 147.992 54C147.992 52.8954 147.09 52 145.977 52C145.038 52 144.249 52.6374 144.026 53.5H136.403V50H135.403ZM145.977 55C146.545 55 146.992 54.5453 146.992 54C146.992 53.4547 146.545 53 145.977 53C145.41 53 144.962 53.4547 144.962 54C144.962 54.5453 145.41 55 145.977 55ZM146.992 59C146.992 59.5453 146.545 60 145.977 60C145.41 60 144.962 59.5453 144.962 59C144.962 58.4547 145.41 58 145.977 58C146.545 58 146.992 58.4547 146.992 59Z"
								fill="#44546F"
							/>
						</g>
						<line x1="20" y1="36.5" x2="247.687" y2="36.5" stroke="#DCDFE4" />
						<g id="Section">
							<text
								fill="#172B4D"
								xmlSpace="preserve"
								fontSize="14"
								fontWeight="600"
								letterSpacing="0px"
							>
								<tspan x="61.3062" y="23.9766">
									{formatMessage(messages.asanaSection)}
								</tspan>
							</text>
							<path
								d="M42.9711 22.8007L37.8421 17.7097C37.2085 17.0808 37.6539 16 38.5466 16H48.8046C49.6973 16 50.1427 17.0809 49.5091 17.7097L44.3801 22.8007C43.9902 23.1878 43.361 23.1878 42.9711 22.8007Z"
								fill="#626F86"
							/>
						</g>
					</g>
					<g id="arrow-right">
						<rect
							width="32"
							height="32"
							transform="translate(271 42)"
							fill="white"
							fillOpacity="0.01"
						/>
						<path
							d="M287.391 65.6094C286.91 65.1288 286.873 64.3725 287.28 63.8494L287.391 63.7239L291.78 59.3346L279 59.3333C278.264 59.3333 277.667 58.7364 277.667 58C277.667 57.3162 278.181 56.7526 278.845 56.6756L279 56.6666L291.783 56.668L287.391 52.2761C286.91 51.7955 286.873 51.0392 287.28 50.5161L287.391 50.3905C287.871 49.9099 288.627 49.8729 289.151 50.2796L289.276 50.3905L295.943 57.0572L296.04 57.1661C296.044 57.1699 296.047 57.1738 296.05 57.1776L295.943 57.0572C295.99 57.1044 296.033 57.1542 296.072 57.2062C296.095 57.2384 296.118 57.2717 296.139 57.3058C296.149 57.3219 296.158 57.3381 296.167 57.3546C296.182 57.3809 296.196 57.4081 296.208 57.4359C296.219 57.4585 296.229 57.4816 296.238 57.5049C296.249 57.5312 296.259 57.5576 296.267 57.5844C296.274 57.6042 296.28 57.6247 296.286 57.6453C296.294 57.6741 296.3 57.703 296.306 57.7322C296.311 57.7555 296.315 57.7788 296.319 57.8021C296.323 57.8274 296.326 57.8535 296.328 57.8799C296.331 57.912 296.332 57.9431 296.333 57.9742C296.333 57.982 296.333 57.991 296.333 58L296.333 58.0258C296.332 58.0569 296.331 58.088 296.328 58.119L296.333 58C296.333 58.0675 296.328 58.1338 296.319 58.1986C296.315 58.2213 296.311 58.2445 296.306 58.2676C296.3 58.297 296.294 58.3259 296.286 58.3545C296.28 58.3753 296.274 58.3958 296.267 58.4162C296.259 58.4424 296.249 58.4687 296.239 58.4947C296.229 58.5183 296.219 58.5414 296.208 58.5643C296.196 58.5918 296.182 58.619 296.167 58.6457C296.158 58.6618 296.149 58.6781 296.139 58.6942C296.118 58.7283 296.095 58.7615 296.072 58.7935C296.066 58.8016 296.06 58.8094 296.054 58.8172C296.016 58.8646 295.981 58.9048 295.943 58.9428L289.276 65.6094C288.755 66.1301 287.911 66.1301 287.391 65.6094Z"
							fill={token('color.text.subtle', '#44546F')}
						/>
					</g>
					<g id="JWM hierarchy">
						<g clipPath="url(#clip0_1_123)">
							<rect x="304" width="270" height="141" fill="#CCE0FF" />
							<path
								d="M531 84H538H542C543.657 84 545 85.3431 545 87V116C545 117.657 543.657 119 542 119H531"
								stroke="#0052CC"
								strokeLinejoin="round"
								strokeDasharray="3 3"
							/>
							<g id="Link">
								<rect width="24" height="24" transform="translate(534 89)" fill="#CCE0FF" />
								<path
									d="M546.654 97.764C546.492 97.9181 546.276 98.0028 546.052 98C545.828 97.9971 545.615 97.9069 545.456 97.7487C545.298 97.5905 545.208 97.3767 545.205 97.153C545.202 96.9292 545.287 96.7132 545.441 96.551L546.655 95.337C547 94.9918 547.41 94.718 547.861 94.5311C548.312 94.3443 548.795 94.2481 549.284 94.2481C549.772 94.2481 550.255 94.3443 550.706 94.5311C551.157 94.718 551.567 94.9918 551.912 95.337C552.258 95.6819 552.532 96.0916 552.719 96.5427C552.907 96.9938 553.003 97.4774 553.003 97.9658C553.003 98.4542 552.907 98.9378 552.72 99.389C552.533 99.8401 552.259 100.25 551.913 100.595L550.699 101.809L549.895 102.613C549.55 102.959 549.14 103.234 548.689 103.421C548.237 103.609 547.753 103.706 547.265 103.706C546.776 103.707 546.292 103.611 545.84 103.424C545.388 103.237 544.978 102.963 544.632 102.618C544.471 102.457 544.381 102.239 544.381 102.011C544.381 101.783 544.471 101.565 544.632 101.404C544.793 101.243 545.011 101.153 545.239 101.153C545.467 101.153 545.685 101.243 545.846 101.404C546.627 102.186 547.896 102.184 548.682 101.399L549.486 100.596L550.7 99.382C550.886 99.1963 551.034 98.9757 551.135 98.7327C551.236 98.4898 551.288 98.2293 551.287 97.9663C551.287 97.7033 551.235 97.4429 551.134 97.2C551.033 96.9571 550.885 96.7366 550.699 96.551C550.513 96.3651 550.293 96.2175 550.05 96.1169C549.807 96.0162 549.547 95.9644 549.284 95.9644C549.021 95.9644 548.761 96.0162 548.518 96.1169C548.275 96.2175 548.055 96.3651 547.869 96.551L546.654 97.764V97.764ZM545.846 104.236C546.008 104.082 546.224 103.997 546.448 104C546.672 104.003 546.885 104.093 547.044 104.251C547.202 104.41 547.292 104.623 547.295 104.847C547.298 105.071 547.213 105.287 547.059 105.449L545.845 106.663C545.5 107.008 545.09 107.282 544.639 107.469C544.188 107.656 543.705 107.752 543.217 107.752C542.728 107.752 542.245 107.656 541.794 107.469C541.343 107.282 540.933 107.008 540.588 106.663C540.242 106.318 539.968 105.908 539.781 105.457C539.593 105.006 539.497 104.523 539.497 104.034C539.497 103.546 539.593 103.062 539.78 102.611C539.967 102.16 540.241 101.75 540.587 101.405L541.801 100.191L542.605 99.387C542.95 99.0409 543.36 98.7663 543.811 98.5787C544.263 98.3911 544.747 98.2943 545.235 98.2939C545.724 98.2934 546.208 98.3893 546.66 98.576C547.112 98.7627 547.522 99.0366 547.868 99.382C548.029 99.543 548.119 99.7613 548.119 99.989C548.119 100.217 548.029 100.435 547.868 100.596C547.707 100.757 547.489 100.847 547.261 100.847C547.033 100.847 546.815 100.757 546.654 100.596C546.467 100.41 546.246 100.263 546.003 100.162C545.759 100.062 545.498 100.011 545.235 100.011C544.972 100.011 544.711 100.064 544.468 100.165C544.225 100.266 544.004 100.414 543.818 100.601L543.014 101.404L541.8 102.618C541.614 102.804 541.466 103.024 541.365 103.267C541.264 103.51 541.213 103.771 541.213 104.034C541.213 104.297 541.265 104.557 541.366 104.8C541.467 105.043 541.615 105.263 541.801 105.449C541.987 105.635 542.207 105.782 542.45 105.883C542.693 105.984 542.953 106.036 543.216 106.036C543.479 106.036 543.739 105.984 543.982 105.883C544.225 105.782 544.445 105.635 544.631 105.449L545.846 104.236Z"
									fill="#0C66E4"
								/>
							</g>
							<g id="Subtask2">
								<g>
									<path
										id="Rectangle 1395"
										d="M325 109C325 105.686 327.686 103 331 103H526C529.314 103 532 105.686 532 109V127C532 130.314 529.314 133 526 133H331C327.686 133 325 130.314 325 127V109Z"
										fill="white"
									/>
								</g>
								<text
									fill="#626F86"
									xmlSpace="preserve"
									fontSize="14"
									fontWeight="500"
									letterSpacing="0px"
								>
									<tspan x="405" y="123.084">
										{formatMessage(messages.jiraSubtask)}
									</tspan>
								</text>
								<g clipPath="url(#clip1_1_123)">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M390 116.5V113.286C390 113.002 389.895 112.729 389.707 112.528C389.52 112.327 389.265 112.214 389 112.214H385C384.735 112.214 384.48 112.327 384.293 112.528C384.105 112.729 384 113.002 384 113.286V117.571C384 117.856 384.105 118.128 384.293 118.329C384.48 118.53 384.735 118.643 385 118.643H388V121.857C388 122.141 388.105 122.414 388.293 122.615C388.48 122.816 388.735 122.929 389 122.929H393C393.265 122.929 393.52 122.816 393.707 122.615C393.895 122.414 394 122.141 394 121.857V117.571C394 117.287 393.895 117.015 393.707 116.814C393.52 116.613 393.265 116.5 393 116.5H390ZM381 111.136C381 109.957 381.895 109 382.994 109H395.006C396.107 109 397 109.959 397 111.136V124.006C397 124.573 396.79 125.116 396.416 125.517C396.042 125.917 395.535 126.143 395.006 126.143H382.994C382.465 126.143 381.958 125.917 381.584 125.517C381.21 125.116 381 124.573 381 124.006V111.136ZM390 118.643H392V120.786H390V118.643ZM386 114.357H388V116.5H386V114.357Z"
										fill="#2684FF"
									/>
								</g>
							</g>
							<g id="Subtask1">
								<g>
									<path
										id="Rectangle 1395_2"
										d="M324 75C324 71.6863 326.686 69 330 69H525C528.314 69 531 71.6863 531 75V93C531 96.3137 528.314 99 525 99H330C326.686 99 324 96.3137 324 93V75Z"
										fill="white"
									/>
								</g>
								<text
									fill="#626F86"
									xmlSpace="preserve"
									fontSize="14"
									fontWeight="500"
									letterSpacing="0px"
								>
									<tspan x="404" y="88.9766">
										{formatMessage(messages.jiraSubtask)}
									</tspan>
								</text>
								<g clipPath="url(#clip2_1_123)">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M389 83V80C389 79.7348 388.895 79.4804 388.707 79.2929C388.52 79.1054 388.265 79 388 79H384C383.735 79 383.48 79.1054 383.293 79.2929C383.105 79.4804 383 79.7348 383 80V84C383 84.2652 383.105 84.5196 383.293 84.7071C383.48 84.8946 383.735 85 384 85H387V88C387 88.2652 387.105 88.5196 387.293 88.7071C387.48 88.8946 387.735 89 388 89H392C392.265 89 392.52 88.8946 392.707 88.7071C392.895 88.5196 393 88.2652 393 88V84C393 83.7348 392.895 83.4804 392.707 83.2929C392.52 83.1054 392.265 83 392 83H389ZM380 77.994C380 76.893 380.895 76 381.994 76H394.006C395.107 76 396 76.895 396 77.994V90.006C396 90.5348 395.79 91.0418 395.416 91.4157C395.042 91.7896 394.535 91.9997 394.006 92H381.994C381.465 91.9997 380.958 91.7896 380.584 91.4157C380.21 91.0418 380 90.5348 380 90.006V77.994ZM389 85H391V87H389V85ZM385 81H387V83H385V81Z"
										fill="#2684FF"
									/>
								</g>
							</g>
							<g id="Issue">
								<g>
									<g>
										<path
											d="M324 41C324 37.6863 326.686 35 330 35H525C528.314 35 531 37.6863 531 41V59C531 62.3137 528.314 65 525 65H330C326.686 65 324 62.3137 324 59V41Z"
											fill="white"
										/>
									</g>
									<text
										fill="#626F86"
										xmlSpace="preserve"
										fontSize="14"
										fontWeight="500"
										letterSpacing="0px"
									>
										<tspan x="380" y="53.9766">
											{formatMessage(messages.jiraIssue)}
										</tspan>
									</text>
									<g clipPath="url(#clip3_1_123)">
										<path
											d="M356 43.6667C356 42.1939 357.194 41 358.667 41H369.333C370.806 41 372 42.1939 372 43.6667V54.3333C372 55.8061 370.806 57 369.333 57H358.667C357.194 57 356 55.8061 356 54.3333V43.6667Z"
											fill="#4C9AFF"
										/>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M368.69 45.61C369.09 45.9913 369.105 46.6243 368.723 47.0238L363.874 52.1045C363.348 52.6548 362.47 52.6548 361.945 52.1045L359.277 49.3095C358.895 48.91 358.91 48.277 359.31 47.8957C359.709 47.5143 360.342 47.5291 360.723 47.9286L362.909 50.2184L367.277 45.6429C367.658 45.2434 368.291 45.2286 368.69 45.61Z"
											fill="white"
										/>
									</g>
									<g id="chevron-down">
										<rect
											width="16"
											height="16"
											transform="translate(332 41)"
											fill="white"
											fillOpacity="0.01"
										/>
										<path
											fillRule="evenodd"
											clipRule="evenodd"
											d="M337.528 47.862C337.403 47.9879 337.334 48.1579 337.334 48.335C337.334 48.5121 337.403 48.6821 337.528 48.808L339.487 50.7847C339.633 50.928 339.821 50.9993 340.007 50.9993C340.193 50.9993 340.377 50.928 340.519 50.7847L342.473 48.8147C342.597 48.6887 342.667 48.5187 342.667 48.3417C342.667 48.1646 342.597 47.9947 342.473 47.8687C342.411 47.8065 342.338 47.7572 342.258 47.7235C342.178 47.6899 342.091 47.6725 342.004 47.6725C341.917 47.6725 341.83 47.6899 341.75 47.7235C341.67 47.7572 341.597 47.8065 341.535 47.8687L340.003 49.4133L338.465 47.862C338.404 47.8001 338.331 47.751 338.251 47.7175C338.17 47.684 338.084 47.6667 337.997 47.6667C337.91 47.6667 337.823 47.684 337.743 47.7175C337.662 47.751 337.589 47.8001 337.528 47.862V47.862Z"
											fill="#42526E"
										/>
									</g>
								</g>
							</g>
							<g id="IssueStatus">
								<rect x="325" y="12" width="88" height="16" rx="3" fill="#DEEBFF" />
								<text
									fill="#0747A6"
									xmlSpace="preserve"
									fontSize="11"
									fontWeight="bold"
									letterSpacing="-0.084px"
								>
									<tspan x="329.184" y="23.9102">
										{formatMessage(messages.jiraIssueStatus)}
									</tspan>
								</text>
							</g>
						</g>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_1_123">
						<rect x="304" width="270" height="141" rx="6" fill="white" />
					</clipPath>
					<clipPath id="clip1_1_123">
						<rect width="16" height="17.1429" fill="white" transform="translate(381 109)" />
					</clipPath>
					<clipPath id="clip2_1_123">
						<rect width="16" height="16" fill="white" transform="translate(380 76)" />
					</clipPath>
					<clipPath id="clip3_1_123">
						<rect width="16" height="16" fill="white" transform="translate(356 41)" />
					</clipPath>
				</defs>
			</svg>
		</>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderWrapper = styled.div({
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	font: token('font.body.UNSAFE_small'),
	fontWeight: token('font.weight.semibold'),
	lineHeight: '16px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N700),
	marginBottom: token('space.100', '8px'),
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AsanaHeader = styled.div({
	marginLeft: token('space.050', '4px'),
	width: '275px',
});

const jiraHeaderStyles = xcss({
	marginLeft: 'space.050',
});

const asanaIconStyles = xcss({
	width: 'space.300',
	height: 'space.300',
	paddingRight: 'space.050',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Image = styled.img({
	width: token('space.300', '24px'),
	height: token('space.300', '24px'),
	paddingRight: token('space.050', '4px'),
});
